import { connect } from 'react-redux';
import AddParticipantDrawer from 'components/AddParticipantDrawer/AddParticipantDrawer';
import { getInviteMailLinkForExtension } from 'actions/Invite';
import {
  searchSelectors,
  callActions,
  callSelectors,
  conferenceSelectors,
  environmentSelectors
} from '@lifesize/nucleus';
import _get from 'lodash/get';
import _find from 'lodash/find';

const mapStateToProps = (state) => {
  const contact = _get(state, 'app.addParticipantDrawer.contact') || {};
  const activeCall = callSelectors.activeCallSelector(state);
  const isGalaxyCall = activeCall.isGalaxyCall;
  const isLockedByModerator = conferenceSelectors.selectIsLocked(state) && !activeCall.isModerator;
  const canAddParticipant = activeCall.canAddParticipants;
  const calling = !!_get(activeCall, 'invitees.length') || !!_get(activeCall, 'failedInvitees.length');
  let callInvitee = null;
  if (_get(activeCall, 'invitees[0]')) {
    callInvitee = activeCall.isGalaxyCall ?
      { contact: _get(activeCall, 'invitees[0]'), dialString: _get(activeCall, 'invitees[0].dialString') } :
      _get(activeCall, 'invitees[0]');
  }
  let failedInvitee = null;
  if (_get(activeCall, 'failedInvitees[0]')) {
    failedInvitee = activeCall.isGalaxyCall ?
      { contact: _get(activeCall, 'failedInvitees[0]'), dialString: _get(activeCall, 'failedInvitees[0].dialString') } :
      _get(activeCall, 'failedInvitees[0]');
  }
  let invitee = callInvitee || failedInvitee;
  const searchString = _get(state, 'app.form.participantSearch.values.addParticipantSearchBar');
  const searchResults =
   searchSelectors.searchUsersAndRoomSystemsOutsideCall(state);
  const manualDial = !searchResults.length && !!searchString;
  const callingError = !!_get(activeCall, 'failedInvitees.length');
  const callType = _get(activeCall, 'failedInvitees[0]') ? 'unreachable' : 'calling';
  const participantsList = _get(activeCall, 'participants');
  let participantAdded = false;
  if (!isGalaxyCall) {
    participantAdded = invitee ? _find(participantsList,
      participant => (participant.dialString === invitee.dialString)) : false;

    if (participantAdded) { // Workaround for CNUC-452
      invitee = null;
    }
  }

  const invitationContact = _get(activeCall, 'remoteContact');

  const isDesktop = environmentSelectors.platform(state).isDesktop;

  return {
    activeCall,
    callType,
    calling,
    callingError,
    canAddParticipant,
    contact,
    invitationContact,
    invitee,
    isDesktop,
    isGalaxyCall,
    isLockedByModerator,
    manualDial,
    participantAdded,
    searchString
  };
};

const mapDispatchToProps = dispatch => ({
  dialExtension: extension => dispatch(callActions.call(extension)),
  endOutgoingCall: (contact) => {
    dispatch(callActions.cancel(contact.dialString));
  },
  clearOutgoingCall: (dialString) => {
    dispatch(callActions.cancel(dialString));
  },
  call: (contact) => {
    if (contact) {
      dispatch(callActions.call(contact));
    }
  },
  getInviteMailLinkForExtension: async extension => dispatch(getInviteMailLinkForExtension(extension))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    getInviteMailLinkForExtension: async () => dispatchProps.getInviteMailLinkForExtension(_get(stateProps, 'invitationContact.dialString')),
    clearOutgoingCall: (contact) => {
      const invitedParticipant = stateProps.activeCall.invitees.find(p => p.dialString === _get(contact, 'dialString'));
      const failedParticipant = stateProps.activeCall.failedInvitees.find(p => p.dialString === _get(contact, 'dialString'));
      if (invitedParticipant || failedParticipant) {
        dispatchProps.clearOutgoingCall(contact.dialString);
      }
    }
  }
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AddParticipantDrawer);
